"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialWindowSafeAreaInsets = exports.initialWindowMetrics = void 0;
const initialWindowMetrics = exports.initialWindowMetrics = null;

/**
 * @deprecated
 */
const initialWindowSafeAreaInsets = exports.initialWindowSafeAreaInsets = null;
//# sourceMappingURL=InitialWindow.js.map